import { ChangeEvent, createContext } from "react";

import { TFunction } from "i18next";

import { ICatalogue } from "@/models/models";

import { CatalogueAction, CatalogueState } from "./components/utils";

type THandlers = {
  handleToggleSwitch: (e: any) => void;
  handleSetFilters: (item: string[]) => void;
  handleToggleModal: () => void;
  handleSearchChange: (value: string, event?: ChangeEvent<HTMLInputElement>) => void;
  handleSearchSubmit: () => void;
  handleResetFilters: () => void;
  handleDeleteFilter: (el: string) => void;
};

export type TMediaPage = {
  state: CatalogueState;
  dispatchReducer: React.Dispatch<CatalogueAction>;
  handlers: THandlers;
  t: TFunction;
  isSmartSearch?: boolean;
  smartSearchHasMore?: boolean;
  smartAlbums?: ICatalogue[];
  handleSmartLoadMore?: () => void;
  localSearch?: string;
  /** Set to the query that returned zero matches; the UI shows a "no exact
   *  match — showing the full catalog" notice above the (fallback) catalog. */
  noResultsQuery?: string;
};

export const CatalogPageContext = createContext<TMediaPage | null>(null);
